import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['expandLabel']

  // Toggle expand/collapse for a single task's children
  toggle(event) {
    const button   = event.currentTarget
    const taskId   = button.dataset.taskId
    const children = this.element.querySelector(`[data-children-of="${taskId}"]`)
    const chevron  = button.querySelector('.wds__chevron')

    if (!children) return

    const isCollapsed = children.classList.contains('d-none')

    if (isCollapsed) {
      children.classList.remove('d-none')
      chevron.classList.remove('fa-chevron-right')
      chevron.classList.add('fa-chevron-down')
      button.classList.remove('wds__toggle--collapsed')
    } else {
      children.classList.add('d-none')
      chevron.classList.remove('fa-chevron-down')
      chevron.classList.add('fa-chevron-right')
      button.classList.add('wds__toggle--collapsed')
    }
  }

  // Expand or collapse all rows
  expandAll(event) {
    const allChildren = this.element.querySelectorAll('[data-children-of]')
    const allChevrons = this.element.querySelectorAll('.wds__chevron')
    const allToggles  = this.element.querySelectorAll('.wds__toggle:not(.wds__toggle--leaf)')

    const anyCollapsed = [...allChildren].some(c => c.classList.contains('d-none'))

    allChildren.forEach(c => {
      if (anyCollapsed) {
        c.classList.remove('d-none')
      } else {
        c.classList.add('d-none')
      }
    })

    allChevrons.forEach(chevron => {
      if (anyCollapsed) {
        chevron.classList.remove('fa-chevron-right')
        chevron.classList.add('fa-chevron-down')
      } else {
        chevron.classList.remove('fa-chevron-down')
        chevron.classList.add('fa-chevron-right')
      }
    })

    allToggles.forEach(toggle => {
      toggle.classList.toggle('wds__toggle--collapsed', !anyCollapsed)
    })
  }
}
